<template>
    <div id="MatrizRiscoDados">
        <div class="row">
            <div class="col-12" v-if="nenhumRiscoDisponivel">
                <div class="alert alert-warning text-center mt-3" role="alert">
                    <strong>Nenhum risco cadastrado.</strong><br />
                    Para gerar um mapa de risco, é necessário cadastrar ao menos um risco relacionado ao processo atual.
                </div>
            </div>

            <template v-else>
                <div class="col-12 text-end">
                    <div class="d-flex justify-content-end">
                        <div class="dropdown">
                            <button class="btn btn-icon btn-light  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                </svg>
                            </button>
                            <ul class="dropdown-menu acoes">
                                <li>
                                    <a class="dropdown-item ds-6" href="javascript:void(0)" @click="gerarPdf">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                        </svg> Baixar PDF
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item ds-6" href="javascript:void(0)" @click="gerarWord">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-word" viewBox="0 0 16 16">
                                            <path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z" />
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                        </svg> Baixar Word
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-12 mtRiscoOut">
                    <div class="scrollContent">
                        <table class="table-lg table-bordered textoCentro tabelaMatrizRiscos">
                            <thead>
                                <tr>
                                    <th style="border: 1px solid #fff; background:#e8e8e8; color: #686868; " colspan="1" class="fixarTab"></th>
                                    <th style="border: 1px solid #fff; background:#e8e8e8; color: #686868; width: 300px !important;" colspan="4" class="">Identificação dos Riscos</th>
                                    <th style="border: 1px solid #eee; background: #f3b88d; " colspan="2" class="mtzAvaliacaoRisco">Avaliação do Risco</th>
                                    <th style="border: 1px solid #eee; background: #efdaa3;" colspan="2" class="mtzNivelRisco">Nível de Risco</th>

                                    <th style="border: 1px solid #eee; background: #ceefa3; " colspan="1" class="mtztratamento">Tratamento</th>

                                    <th scope="col" style="border: 1px solid #eee !important; background: #b5e1f4;" colspan="4" class="mtzControlesAcao">Controles e Planos de Ação</th>

                                    <th scope="col" style="border: 1px solid #eee !important; background: #b7c8f4;" colspan="2" class="mtzControlesAcao">Resultado Planos de Ação</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th style="background-color: #e8e8e8; color: #686868;" class="fixarTab headcol">ID Risco</th>
                                    <td style="background-color: #e8e8e8; color:#686868;" class="headcol">Categoria</td>
                                    <td style="background-color: #e8e8e8; color: #686868;" class="headcol">Evento de Risco</td>
                                    <td style="background-color: #e8e8e8; color: #686868;" class="headcol">
                                        Causas
                                    </td>
                                    <td style=" background-color:#e8e8e8; color:#686868;" class="headcol">Consequências</td>

                                    <td style="background: #f3b88d;" class="mtzAvaliacaoRisco headcol">Probabilidade</td>
                                    <td style="background: #f3b88d;" class="mtzAvaliacaoRisco headcol">Impacto</td>

                                    <td style="background: #efdaa3;" class="mtzNivelRisco headcol">Risco Inerente</td>
                                    <td style="background: #efdaa3;" class="mtzNivelRisco headcol">Risco Residual</td>

                                    <td style="background: #ceefa3;" class="mtztratamento headcol">Resposta ao risco</td>

                                    <td style="background: #b5e1f4;" class="mtzplanoAcao headcol">Plano de Ação</td>
                                    <td style="background: #b5e1f4; width: 44%; min-width: 200px !important;" colspan="3" class="mtzplanoAcao headcol">Descrição do Plano</td>
                                    <td style="background: #b7c8f4;" class="mtzplanoAcao headcol">Força do Plano de Ação</td>
                                    <td style="background: #b7c8f4;" class="mtzplanoAcao headcol">Resultado do Plano de Ação</td>
                                </tr>

                                <tr v-for="(item,index) in matriz" :key="index">
                                    <td class="fixme fixarTab headcol" :style="'background-color:'+ getBg(index)">
                                        {{item.risco.cdRisco}}
                                    </td>
                                    <td :style="'background-color:'+ getBg(index)">
                                        {{item.riscoCategoria.nmCategoria}}
                                    </td>
                                    <td :style="'background-color:'+ getBg(index)">
                                        {{item.risco.dsTitulo}}
                                    </td>
                                    <!--<td colspan="2" :style="'background-color:'+ getBg(index)">
                                <table class="subTabelaMatriz" style="width: 100%;" v-if="item.causaConsequencias">
                                    <tr v-for="i in (Math.max(item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CA').length,item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CO').length))" :key="i">
                                        <td>
                                            <template v-if="item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CA')[i-1]">
                                                {{item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CA')[i-1].nmRiscoCausaConsequencia}}
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CO')[i-1]">
                                                {{item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CO')[i-1].nmRiscoCausaConsequencia}}
                                            </template>
                                        </td>
                                    </tr>
                                </table>
                            </td>-->
                                    <td :style="'background-color:'+ getBg(index)">
                                        <template v-for="(causa,index2) in item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CA')">
                                            <span class="d-inline-block mb-2" :key="index2">
                                                {{causa.nmRiscoCausaConsequencia}}
                                            </span>
                                        </template>

                                    </td>
                                    <td :style="'background-color:'+ getBg(index)">
                                        <template v-for="(causa,index3) in item.causaConsequencias.filter(x=>x.tpRiscoCausaConsequencia == 'CO')">
                                            <span class="d-inline-block mb-2" :key="index3">
                                                {{causa.nmRiscoCausaConsequencia}}
                                            </span>
                                        </template>
                                    </td>
                                    <template v-if="item.nivelEscalaProbabilidade">
                                        <td :class="item.nivelEscalaProbabilidade.replace(' ','')">
                                            {{item.nivelEscalaProbabilidade}}
                                        </td>
                                    </template>
                                    <template v-if="item.nivelEscalaQualitativa">
                                        <td :class="item.nivelEscalaQualitativa.replace(' ','')">
                                            {{item.nivelEscalaQualitativa}}
                                        </td>
                                    </template>

                                    <td :class="'inerente-'+item.riscoInerente">
                                        {{item.riscoInerente}}
                                    </td>
                                    <td :class="'riscoResidual-'+item.riscoResidual">
                                        {{item.riscoResidual}}
                                    </td>

                                    <td :class="item.risco.respostaAoRisco" :style="'background-color:'+ getBg(index)">
                                        {{item.risco.respostaAoRisco}}
                                    </td>

                                    <td colspan="4" :style="'background-color:'+ getBg(index)">
                                        <table class="subTabelaMatriz" style="width: 100%;">

                                            <tr v-for="(plano,index4) in item.planos" :key="index4">
                                                <td style="width: 18%;">
                                                    {{plano.cdPlanoAcao}} - {{plano.dsTitulo}}
                                                </td>
                                                <td>
                                                    {{plano.dsPlanoAcao}}
                                                </td>
                                            </tr>

                                        </table>
                                    </td>

                                    <td :class="'forcaPlanoAcao-'+item.risco.forcaPlanoAcao" :style="'background-color:'+ getBg(index)">
                                        {{item.risco.forcaPlanoAcao}}
                                    </td>

                                    <td :class="''+item.risco.resultadoPlanoAcao.trim()" :style="'background-color:'+ getBg(index)">
                                        {{item.risco.resultadoPlanoAcao}}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                </template>
        </div>
    </div>
</template>


<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'

    export default {
        props: {
            idProcesso: String,
            idProcessoModeloArtefato: String,
            refresh: Boolean,
        },
        data() {
            return {

                matriz: [

                ]
            };
        },

        computed: {
            nenhumRiscoDisponivel() {
                return this.matriz.length === 0;
            }
        },

        methods: {
            load() {
                this.GetMatriz();
            },

            getBg(index) {
                return index % 2 == 0 ? "#fff" : "#f4f4f4"
            },

            GetMatriz() {
                let $this = this;
                axios.get(`${urlApi}/GerenciamentoRisco/GetMatriz/${this.idProcesso}`)
                    .then(res => {
                        $this.lstProcessoArtefatoHistorico = null;
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.matriz = result;
                        } else {
                            avisoErro("Não foi possível carregar o mapa.");
                            avisoToast("Não foi possível carregar o mapa.")
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar o mapa.");
                        }
                    });
            },

            gerarPdf() {
                let $this = this;
                axios({
                    method: 'GET',
                    url: `${urlApi}/GerenciamentoRisco/DownloadPdf/${$this.idProcesso}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `mapa_risco.pdf`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        console.error("Erro ao gerar PDF:", error);
                        avisoErro("Erro ao gerar PDF");
                    });
            },

            gerarWord() {
                let $this = this;
                axios({
                    method: 'GET',
                    url: `${urlApi}/GerenciamentoRisco/DownloadWord/${$this.idProcesso}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `mapa_risco.docx`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        console.error("Erro ao gerar PDF:", error);
                        avisoErro("Erro ao gerar PDF");
                    });
            },

            vincularMatrizProcesso() {
                let $this = this;
                axios.post(`${urlApi}/GerenciamentoRisco/VincularMatrizProcesso`, { idProcesso: $this.idProcesso, idProcessoModeloArtefato: $this.idProcessoModeloArtefato })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Mapa vinculado com sucesso.");
                            $this.$store.commit('setReload');
                        } else {
                            avisoErro("Erro ao salvar: " + (res.data.msg || "Erro inesperado."));
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data) {
                            const msg = err.response.data.msg;
                            const extra = err.response.data.errors?.[0] || '';
                            avisoErro(`${msg} ${extra}`);
                        } else {
                            avisoErro("Erro ao salvar o mapa.");
                        }
                    });
            },
        },

        mounted: function () {
            this.load();
        },
        watch: {
            idProcesso: function () {
                this.load();
            },
            refresh: function () {
                this.load();
            },
        }
    }
</script>
<style lang="scss" scoped>
    /* matriz */
    #MatrizRiscoDados .select-aqua {
        border: 1px solid rgb(2 166 171) !important;
    }

    #MatrizRiscoDados .nmResponsavel {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        color: #565656;
        text-transform: capitalize;
    }

    #MatrizRiscoDados p::first-letter {
        /*text-transform: capitalize;*/
    }


    #MatrizRiscoDados .headcol {
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 13px !important;
        color: #565656 !important;
    }


    #MatrizRiscoDados .mtRiscoOut {
        background: white;
        padding: 15px 5px;
        border-radius: 5px;
    }

    #MatrizRiscoDados .mtzplanoAcao {
        border: 1px solid #eee;
        border-left: 1px solid #eee !important;
        border-top: none !important;
        /* border-bottom: none !important;*/
    }

    #MatrizRiscoDados td {
        min-width: 130px;
        height: 50px;
    }

    #MatrizRiscoDados .progress .indeterminate {
        background-color: linear-gradient(99.53deg, #00859D 14.37%, #00556C 100%) !important;
        background-color: #1a91a7 !important;
    }

    #MatrizRiscoDados .no-overflow {
        overflow: hidden;
        width: 40%;
    }

    #MatrizRiscoDados .riscoResidual-Baixo {
        background: #c6efce;
    }

    #MatrizRiscoDados .riscoResidual-Médio {
        background: #ffe599;
    }

    #MatrizRiscoDados .tabelaMatrizRiscos {
        border-collapse: collapse;
        width: 99%;
    }


    #MatrizRiscoDados .tabelaMatrizRiscos th, .tabelaMatrizRiscos td {
        font-size: 0.8rem !important;
        text-align: center;
        color: #686868;
        border: 1px solid #fff !important;
    }

    #MatrizRiscoDados .tabelaMatrizRiscos.td, .tabelaMatrizRiscos.th {
        margin: 0;
        border: 3px solid grey;
        border-top-width: 0px;
        white-space: nowrap;
    }

    #MatrizRiscoDados .scrollContent {
        /* width: 100%;
    overflow-x: scroll;
    margin-left: 5em;
    overflow-y: visible;
    padding-bottom: 1px;
    margin-left: 10px;*/

        width: calc(100% - 10px);
        overflow-x: scroll;
        margin-left: 5em;
        overflow-y: visible;
        padding-bottom: 1px;
        margin-left: 5px;
    }

    #MatrizRiscoDados .fixarTab {
        position: sticky;
        width: 5em;
        left: 0;
        top: auto;
        border-right: 0px none black;
        border-top-width: 3px; /*only relevant for first row*/
        margin-top: -3px; /*compensate for top border*/
    }

    #MatrizRiscoDados .long {
        background: yellow;
        letter-spacing: 1em;
    }



    #MatrizRiscoDados .tabelaMatrizRiscos td, .tabelaMatrizRiscos th {
        border: 1px solid #eee;
    }

    #MatrizRiscoDados .subTabelaMatriz td, .subTabelaMatriz th {
        border: none !important;
    }

    #MatrizRiscoDados .subTabelaMatriz tr {
        border-bottom: 1px solid #9d9d9d !important;
    }

    #MatrizRiscoDados .subTabelaMatriz tr:last-child {
        border-bottom: none !important;
    }

    #MatrizRiscoDados .tituloGestaoRisco {
        border: 2px solid black;
        text-align: center;
        padding: 10px;
        background-color: rgb(252,228,214);
    }

    #MatrizRiscoDados .mtzAvaliacaoRisco {
        background-color: rgb(198,89,17);
        color: white;
    }

    #MatrizRiscoDados .mtzNivelRisco {
        background-color: rgb(244,176,132);
    }

    #MatrizRiscoDados .mtztratamento {
        background-color: rgb(131,60,12);
        color: white;
    }

    #MatrizRiscoDados .mtzControlesAcao {
        background-color: rgb(191,143,0);
        color: white;
    }

    #MatrizRiscoDados .mtzplanoAcao {
        background-color: rgb(255,192,0);
    }

    #MatrizRiscoDados .MuitoAlto {
        /*background-color: rgb(255,124,128);*/
        background-color: #FFC7CE;
    }

    #MatrizRiscoDados .Alto {
        background-color: #F8CEB2;
    }

    #MatrizRiscoDados .Médio, #MatrizRiscoDados .Moderado{
        background-color: #FFEB9C;
    }

    #MatrizRiscoDados .Baixo {
        background-color: #C6EFCE;
        /*background-color: rgb(197,224,179)*/
    }

    #MatrizRiscoDados .MuitoBaixo {
        /*background-color: rgb(168,208,141)*/
        /*background-color: #c6efce8c;*/
        background-color: #e5f5e8;
    }

    #MatrizRiscoDados .inerente-Extremo {
        /*background-color: rgb(253, 105, 110);*/
        background-color: #FFC7CE;
        /*color: rgb(190, 59, 52);*/
    }

    #MatrizRiscoDados .inerente-Alto {
        background-color: #F8CEB2;
        /*color: rgb(237, 125, 49);*/
    }

    #MatrizRiscoDados .riscoResidual-Alto {
        background-color: #F8CEB2;
        /*color: rgb(237, 125, 49);*/
    }

    #MatrizRiscoDados .inerente-Médio, MatrizRiscoDados .inerente-Moderado {
        background-color: rgb(255, 235, 156);
        /*color: rgb(156, 126, 88);*/
    }

    #MatrizRiscoDados .inerente-Baixo {
        /*    background-color: rgb(198, 239, 206);
    color: rgb(44, 97, 0);*/

        background-color: #C6EFCE;
    }

    #MatrizRiscoDados .scrollContent {
        overflow-x: auto;
    }
</style>

